import {
    BrandVariants,
    GriffelStyle,
    Theme,
    createDarkTheme,
    createLightTheme,
    makeStyles,
    shorthands,
    themeToTokensObject,
    tokens,
} from '@fluentui/react-components';

export const semanticKernelBrandRamp: BrandVariants = {
    10: '#000000',
    20: '#1A1A1A',
    30: '#333333',
    40: '#4D4D4D',
    50: '#666666',
    60: '#CA152B',
    70: '#F35D54',
    80: '#EC1E24',
    90: '#CCCCCC',
    100: '#E6E6E6',
    110: '#F0F0F0',
    120: '#F5F5F5',
    130: '#FAFAFA',
    140: '#FCFCFC',
    150: '#FDFDFD',
    160: '#FEFEFE',
};

export const semanticKernelLightTheme: Theme & {
    colorMeBackground: string;
    colorTextLight: string;
    colorRedButton: string;
    colorBlackButton: string;
    colorTextDisabled: string;
    colorRedBackground: string;
    colorContentWrapper: string;
    colorButtonBorder: string;
    colorInputBackground: string;
    colorSendButton: string;
    colorTextBlack: string;
    actionButtonColorFilter: string;
    colorChatRoomBackground: string;
    colorChatRoomHeaderBackgroud: string;
    colorCustomText: string;
    colorSelectedItem: string;
    colorTextDisabled2: string;
    colorSeperator: string;
    colorDocumentButton: string;
    colorBorder: string;
    colorGreetingText: string;
    colorTags: string;
    colorBotMessageBackground: string;
    colorBotMessageText: string;
    colorDangerHoverBackground: string;
    colorInfoBackground: string;
    colorInfoBorder: string;
    colorLinkUserMessage: string,
    colorLinkUserMessageHover: string,
    colorLinkUserMessageActive: string,
    colorLinkAssistantMessage: string,
    colorLinkAssistantMessageHover: string,
    colorLinkAssistantMessageActive: string
} = {
    ...createLightTheme(semanticKernelBrandRamp),
    fontFamilyBase: 'Roboto, sans-serif',
    colorMeBackground: '#EC1E24',
    colorTextLight: '#757575',
    colorRedButton: '#FF4B50',
    colorBlackButton: '#1E1F2A',
    colorTextDisabled: '#757575',
    colorRedBackground: '#FFD1D2',
    colorContentWrapper: '#FFF',
    colorButtonBorder: '#F0F0F0',
    colorInputBackground: '#F6F6F6',
    colorSendButton: '#FFFFFF',
    colorTextBlack: '#1E1F2A',
    actionButtonColorFilter: '',
    colorChatRoomBackground: '#F7F8F9',
    colorChatRoomHeaderBackgroud: '#FFFFFF',
    colorCustomText: '#0D0D0D',
    colorSelectedItem: '#EFEFEF',
    colorTextDisabled2: '#8F8F8F',
    colorSeperator: '#F0F0F0',
    colorDocumentButton: '#1E1F2AE5',
    colorBorder: '#F0F0F0',
    colorGreetingText: '#757575',
    colorTags: '#FFFFFF',
    colorBotMessageBackground: '#FFFFFF',
    colorBotMessageText: '#1E1F2A',
    colorDangerHoverBackground: 'rgba(196, 49, 75, 0.1)',
    colorInfoBackground: 'rgba(0, 120, 212, 0.05)',
    colorInfoBorder: 'rgba(0, 120, 212, 0.15)',
    colorLinkUserMessage: '#F5F5F5',
    colorLinkUserMessageHover: '#FFFFFF',
    colorLinkUserMessageActive: '#E8E8E8',
    colorLinkAssistantMessage: '#1565C0',
    colorLinkAssistantMessageHover: '#0D47A1',
    colorLinkAssistantMessageActive: '#1976D2',
};

export const semanticKernelDarkTheme: Theme & {
    colorMeBackground: string;
    colorTextLight: string;
    colorRedButton: string;
    colorBlackButton: string;
    colorTextDisabled: string;
    colorRedBackground: string;
    colorContentWrapper: string;
    colorButtonBorder: string;
    colorInputBackground: string;
    colorSendButton: string;
    colorTextBlack: string;
    actionButtonColorFilter: string;
    colorChatRoomBackground: string;
    colorChatRoomHeaderBackgroud: string;
    colorCustomText: string;
    colorSelectedItem: string;
    colorTextDisabled2: string;
    colorSeperator: string;
    colorDocumentButton: string;
    colorBorder: string;
    colorGreetingText: string;
    colorTags: string;
    colorBotMessageBackground: string;
    colorBotMessageText: string;
    colorDangerHoverBackground: string;
    colorInfoBackground: string;
    colorInfoBorder: string;
    colorLinkUserMessage: string,
    colorLinkUserMessageHover: string,
    colorLinkUserMessageActive: string,
    colorLinkAssistantMessage: string,
    colorLinkAssistantMessageHover: string,
    colorLinkAssistantMessageActive: string
} = {
    ...createDarkTheme(semanticKernelBrandRamp),
    fontFamilyBase: 'Roboto, sans-serif',
    colorMeBackground: '#EC1E24',
    colorTextLight: '#F5F6FA',
    colorRedButton: '#FF4B50',
    colorBlackButton: '#FFFFFF',
    colorTextDisabled: '#757575',
    colorRedBackground: '#FFD1D2',
    colorContentWrapper: '#2B2B2B',
    colorButtonBorder: '#515151',
    colorInputBackground: '#1E1E1E',
    colorSendButton: '#1E1F2A',
    colorTextBlack: '#1E1F2A',
    actionButtonColorFilter: 'brightness(0) invert(1)',
    colorChatRoomBackground: '#252627',
    colorChatRoomHeaderBackgroud: '#1E1E1E',
    colorCustomText: '#FFFFFF',
    colorSelectedItem: '#333333',
    colorTextDisabled2: '#F5F6FA',
    colorSeperator: '#818181',
    colorDocumentButton: '#F5F6FA',
    colorBorder: '#2D2D2D',
    colorGreetingText: '#BBBBBB',
    colorTags: '#1E1E1E',
    colorBotMessageBackground: '#323232',
    colorBotMessageText: '#FFFFFF',
    colorDangerHoverBackground: 'rgba(255, 75, 80, 0.15)',
    colorInfoBackground: 'rgba(70, 150, 230, 0.08)',
    colorInfoBorder: 'rgba(70, 150, 230, 0.25)',
    colorLinkUserMessage: '#F5F5F5',
    colorLinkUserMessageHover: '#FFFFFF',
    colorLinkUserMessageActive: '#E8E8E8',
    colorLinkAssistantMessage: '#4FC3F7',
    colorLinkAssistantMessageHover: '#29B6F6',
    colorLinkAssistantMessageActive: '#0288D1',
};

// Helper function to dynamically get custom tokens based on theme
export const getCustomTokens = (theme: typeof semanticKernelLightTheme | typeof semanticKernelDarkTheme) =>
    themeToTokensObject(theme);

export const customTokens = themeToTokensObject(semanticKernelLightTheme);

// Simple Breakpoints system
export const breakpointValues = {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1448,
} as const;

export type BreakpointKey = keyof typeof breakpointValues;

// Helper functions for breakpoints
export const breakpointUp = (breakpoint: BreakpointKey): string => {
    const value = breakpointValues[breakpoint];
    return `(min-width: ${value}px)`;
};

export const breakpointDown = (breakpoint: BreakpointKey): string => {
    const value = breakpointValues[breakpoint];
    return `(max-width: ${value - 1}px)`;
};

// Legacy Breakpoints for backward compatibility
export const Breakpoints = {
    small: (style: GriffelStyle): Record<string, GriffelStyle> => {
        return { '@media (max-width: 900px)': style };
    },
};

export const ScrollBarStyles: GriffelStyle = {
    overflowY: 'auto',
    '&:hover': {
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: tokens.colorScrollbarOverlay,
            visibility: 'visible',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: tokens.colorNeutralBackground1,
            WebkitBoxShadow: 'inset 0 0 5px rgba(0, 0, 0, 0.1)',
            visibility: 'visible',
        },
    },
};

export const SharedStyles: Record<string, GriffelStyle> = {
    scroll: {
        height: '100%',
        ...ScrollBarStyles,
    },
    overflowEllipsis: {
        ...shorthands.overflow('hidden'),
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
};

export const useSharedClasses = makeStyles({
    informativeView: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.padding('80px'),
        alignItems: 'center',
        ...shorthands.gap(tokens.spacingVerticalXL),
        marginTop: tokens.spacingVerticalXXXL,
    },
});

export const useDialogClasses = makeStyles({
    surface: {
        paddingRight: tokens.spacingVerticalXS,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.overflow('hidden'),
        width: '100%',
    },
    paragraphs: {
        marginTop: tokens.spacingHorizontalS,
    },
    innerContent: {
        height: '100%',
        ...SharedStyles.scroll,
        paddingRight: tokens.spacingVerticalL,
    },
    text: {
        whiteSpace: 'pre-wrap',
        textOverflow: 'wrap',
    },
    footer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        minWidth: '175px',
    },
});
